import React from 'react';

import Card from '@components/Card';
import Button from '@shared/Button';
import Modal from '@shared/Modal';
import ButtonsRow from '@styled/Containers/ButtonsRow';
import A from '@styled/Elements/A';
import P from '@styled/Elements/P';

export default function SupportModal({ isOpen, handleTeardown }) {
  return (
    <Modal id='modal' open={isOpen} toggle={handleTeardown}>
      <Card title='Contact Support' shadow>
        <P>
          Reach out to us at{' '}
          <A
            href='mailto:screen.team@enigma.com'
            target='_blank'
            rel='noopener noreferrer'
          >
            screen.team@enigma.com
          </A>{' '}
          with any inquiries that you have.
        </P>
        <ButtonsRow>
          <Button
            analyticsName='Support Modal - Dismiss'
            onClick={handleTeardown}
          >
            Dismiss
          </Button>
        </ButtonsRow>
      </Card>
    </Modal>
  );
}
